module.exports = __webpack_public_path__ + "img/lg_ring_r_e_1_1@3x.ff2a7acd.png";